module.exports = __webpack_public_path__ + "img/france-female.2cfd3d33.png";